export default "__VITE_ASSET__f314d4c8__"